module.exports = __webpack_public_path__ + "img/exam-title.f4c05e27.png";